import { equals, uniq } from 'ramda'
import sortStrings from './sort-strings'

const sameUniqValues = (array1, array2) => equals(
  sortStrings(uniq(array1)),
  sortStrings(uniq(array2))
)

export default sameUniqValues
